import {
  Grid,
  Button,
  Box,
  Modal,
  Typography,
  Stack,
  Alert,
  Tooltip,
  MenuItem,
  TextField
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useEffect, useState } from 'react';
import { deleteAdmin, getAllAdmins, setAdmin } from '../../services/Admin';
import {getAllAccounts} from "../../services/Account";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const AdministerAdmins = () => {
  const [admins, setAdmins] = useState([]);
  const [users, setUsers] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [newAdmin, setNewAdmin] = useState();
  const [removeBtn, setRemoveBtn] = useState('');

  useEffect(() => {
    getAllAdmins().then(setAdmins);
    getAllAccounts().then(setUsers);
  }, []);

  const removeAdmin = (uid) => {
    if (removeBtn === uid) {
      deleteAdmin(uid).then(() => {
        setAdmins(admins.filter((admin) => admin.uid !== uid));
      });
    } else {
      setRemoveBtn(uid);
    }
  };

  const createNewAdmin = () => {
    newAdmin !== null &&
      setAdmin(newAdmin).then(() => {
        setAdmins([...admins, { uid: newAdmin }]);
        setAddModal(false);
        getAllAdmins().then(setAdmins);
      });
  };

  const columns = [
    {
      field: 'club',
      headerName: 'Klubb',
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 2,
    },
    {
      field: 'delete',
      headerName: '',
      flex: 1,
      renderCell: ({ row }) => (
        <Tooltip
          title="Trykk igjen for å slette"
          open={removeBtn === row.uid}
          placement="right"
          arrow
          disableHoverListener
        >
          <Button
            color={removeBtn === row.uid ? 'error' : 'info'}
            onClick={() => removeAdmin(row.uid)}
            startIcon={<RemoveCircleOutlineIcon />}
          >
            Fjern
          </Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <Grid container columnSpacing={2} mb={2}>
        <Grid item xs={9}>
          <Alert severity="warning">Merk! Denne siden gjør permanente endringer som ikke kan reverseres.</Alert>
        </Grid>
        <Grid item xs={3}>
          <Button onClick={() => setAddModal(true)} variant="contained" fullWidth>
            Legg til ny
          </Button>
        </Grid>
      </Grid>
      <Box height="50vh">
        <DataGrid columns={columns} rows={admins} getRowId={(row) => row.uid} autoPageSize />
      </Box>
      <Modal open={addModal} onClose={() => setAddModal(false)}>
        <Box sx={style}>
          <Stack spacing={2}>
            <Typography variant="h6" component="h2" mb={2}>
              Legg til ny admin
            </Typography>
            <TextField select label="Brukere" onChange={({target}) => setNewAdmin(target.value)}>
              {users.map(user => <MenuItem value={user.uid}>{user.name}</MenuItem>)}
            </TextField>
            <Button onClick={createNewAdmin} variant="contained">
              Legg til
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default AdministerAdmins;
